__turbopack_context__.v({
  "circle": "WalletConfirmed-module__1XuW-G__circle",
  "root": "WalletConfirmed-module__1XuW-G__root",
  "unconfirmed": "WalletConfirmed-module__1XuW-G__unconfirmed",
});
